import { Modal, ModalHeader } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import CelebrateImage from '../../Cutesies/CelebrateImage';
import {
  PublishCelebration,
  SaveCelebration,
} from '../LearningCollection/ChatbotPreview/LearningCollectionPreviewStore/Types';
import LearningCollectionModal from './LearningCollectionModal';
import { useNavigate } from 'react-router-dom';

interface Props {
  state: PublishCelebration | SaveCelebration;
}

function PublishedCollectionModal({ state }: Props) {
  const navigate = useNavigate();
  const handleClose = () => {
    navigate('/home');
  };
  return (
    <Modal size="3xl" open={true} onClose={handleClose} className="flex flex-col items-center py-9">
      <ModalHeader>
        <CelebrateImage width="246" height="161" />
      </ModalHeader>
      <LearningCollectionModal state={state} onClose={handleClose} />
    </Modal>
  );
}

export default observer(PublishedCollectionModal);
